<style lang="scss" scoped>
  .AppDrawer {
    padding: 0;
    margin: 0;
    position: absolute;
    width: 389px;
    height: 100%;
    background: #ffffff;
    top: 0;
    left: -330px;
    transition: all 500ms linear;

    @media only screen and (max-width: 1000px) {
      width: 270px;
      left: -211px;
    }

    &__active {
      position: absolute;
      width: 389px;
      height: 100%;
      left: 0;
      background: #ffffff;
      box-shadow: 0 60px 12px 3px #bebebe;
      transition: all 500ms linear;
      overflow: auto;

      @media only screen and (max-width: 1000px) {
        width: 270px;
      }
    }

    &__header {
      position: fixed;
      height: 60px;
      width: 389px;
      background-color: #ffffff;
      
      @media only screen and (max-width: 1000px) {
        width: 270px;
      }
    }

    &__items {
      padding-top: 92px;
    }
  }
</style>

<template lang="pug">
  .AppDrawer(:class="closed ? '' : 'AppDrawer__active'")
    DrawerHeader.AppDrawer__header(:title="title", :hideToggleButton="hideToggleButton", :hideHeader="hideHeader", :backLink="backLink", :closed="closed", @toggle="onToggle")
    DrawerItems.AppDrawer__items(:items="drawerItems", v-show="!closed")
</template>

<script>
  import DrawerHeader from './components/DrawerHeader';
  import DrawerItems from './components/DrawerItems';

  export default {
    name: 'AppDrawer',
    components: {
      DrawerHeader,
      DrawerItems,
    },

    props: {
      title: String,

      hideToggleButton: {
        type: Boolean,
        default: false,
      },

      hideHeader: {
        type: Boolean,
        default: false,
      },

      backLink: {
        type: String,
        default: '/',
      },

      // each drawerItem must be defined as an object with the given properties
      // {
      //    component             : (required) the vue component,
      //    props                 : (optional) any properties that the component needs,
      //    onData(somedata) {}   , (optional) Callback function which gets called when
      //                            the component calls this.$emit('data', somedata),
      //    onRemove(somedata) {}  , (optional) Callback function which gets called when
      //                             the component calls this.$emit('remove', somedata)
      // }
      drawerItems: {
        type: Array,
        required: true,
      },
    },

    data() {
      return {
        closed: false,
      };
    },

    methods: {
      onToggle() {
        this.closed = !this.closed;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/AppDrawer/AppDrawer.vue